<template>
    <v-container fluid class="pa-0">
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        {{ modelName }}
                    </v-card-title>
                    <v-card-text>
                        <slot name="description"></slot>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" @click="create">Create {{ this.modelName }}</v-btn>
                    </v-card-actions>
                </v-card>
                <slot name="table"></slot>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ModelListContainer",

    props: {
        modelName: {
            type: String,
            required: true,
        },
    },

    computed: {},

    methods: {
        create() {
            this.$emit("create");
        },
    },

    data() {
        return {};
    },
});
</script>

<style></style>
